import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /Users/ijaemun/Documents/Codex/2026-09-30/task/migration-prep/mac-candidate-build/src/app/page.access/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.access-page {
  width: 100%;
  height: 100vh;
  height: 100svh;
  height: 100dvh;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.access-layout {
  grid-template-columns: minmax(0, 1fr);
  min-height: 100%;
}

.access-hero {
  display: none;
}

.access-form-section {
  min-width: 0;
  min-height: 100%;
  align-items: safe center;
  justify-content: safe center;
}

.access-form-shell {
  width: 100%;
}

.access-mobile-brand {
  display: block;
}

.signup-overlay {
  backdrop-filter: blur(4px);
}

.signup-panel {
  max-height: min(720px, 100vh - 2rem);
  max-height: min(720px, 100dvh - 2rem);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 767px) {
  .access-page {
    font-size: 13px;
  }
  .access-form-section {
    align-items: flex-start;
    padding-top: max(1.5rem, env(safe-area-inset-top));
    padding-bottom: max(1.5rem, env(safe-area-inset-bottom));
  }
  .access-mobile-brand {
    margin-bottom: 1.5rem;
  }
  .access-mobile-brand p:first-of-type {
    font-size: 13px;
    line-height: 1.35;
  }
  .access-mobile-brand p:last-of-type,
  .access-footer {
    font-size: 11px;
    line-height: 1.4;
  }
  .access-form-shell {
    max-width: 100%;
  }
  .access-card {
    padding: 1.25rem;
    box-shadow: 0 18px 36px rgba(148, 163, 184, 0.28);
  }
  .access-card > div:first-child {
    margin-bottom: 1.25rem;
  }
  .access-card h2 {
    font-size: 1.375rem;
    line-height: 1.25;
  }
  .access-card p,
  .access-card span,
  .access-card input,
  .access-card button,
  .signup-panel p,
  .signup-panel span,
  .signup-panel input,
  .signup-panel button {
    font-size: 12px;
  }
  .access-card p,
  .signup-panel p {
    line-height: 1.55;
  }
  .access-card input,
  .access-card button,
  .signup-panel input,
  .signup-panel button {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .signup-panel {
    padding: 1.25rem;
  }
  .signup-panel h2 {
    font-size: 1.375rem;
    line-height: 1.25;
  }
  .access-card .space-y-5 > :not([hidden]) ~ :not([hidden]) {
    margin-top: 1rem;
  }
  .access-footer {
    margin-top: 1.25rem;
  }
}
@media (max-width: 380px) {
  .access-card,
  .signup-panel {
    padding: 1rem;
  }
  .access-card h2,
  .signup-panel h2 {
    font-size: 1.25rem;
  }
}
@media (max-height: 640px) {
  .access-form-section {
    align-items: flex-start;
  }
}
@media (min-width: 768px) and (max-width: 1279px) {
  .access-form-section {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
@media (min-width: 1280px) and (hover: hover) and (pointer: fine) {
  .access-layout {
    grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
  }
  .access-hero {
    display: block;
  }
  .access-mobile-brand {
    display: none;
  }
  .access-form-section {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = false;
    public oidcEnabled: boolean = false;
    public signupOpen: boolean = false;
    public signupLoading: boolean = false;
    public emailDomain: string = '@isri.co.kr';

    public data: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        email: '',
        name: '',
        mobile: '',
        department: '',
        password: '',
        passwordConfirm: ''
    };

    public async ngOnInit() {
        await this.service.init();
        await this.loadAuthOptions();
        let check = await this.service.auth.check();
        if (check) return location.href = this.returnTo();
        await this.service.render();
        await this.showApprovalPendingNotice();
    }

    private async loadAuthOptions() {
        try {
            const { code, data } = await wiz.call("auth_options");
            this.oidcEnabled = code === 200 && data?.oidcEnabled === true;
        } catch (e) {
            this.oidcEnabled = false;
        }
    }

    private returnTo() {
        const params = new URLSearchParams(location.search || '');
        const returnTo = params.get('returnTo') || '/chatbot';
        if (!returnTo.startsWith('/') || returnTo.startsWith('//')) return '/chatbot';
        return returnTo;
    }

    public oidcLogin() {
        location.href = `/auth/oidc/login?returnTo=${encodeURIComponent(this.returnTo())}`;
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    private async showApprovalPendingNotice() {
        const params = new URLSearchParams(location.search || '');
        if (params.get('approval') !== 'pending') return;

        params.delete('approval');
        const query = params.toString();
        const nextUrl = `${location.pathname}${query ? '?' + query : ''}${location.hash || ''}`;
        history.replaceState({}, document.title, nextUrl);

        await this.alert("아직 승인 처리중입니다.", 'warning');
    }

    private normalizeEmail(email: string = '') {
        email = String(email || '').trim().toLowerCase();
        if (email && email.indexOf('@') === -1) email = `${email}${this.emailDomain}`;
        return email;
    }

    private normalizeLoginId(value: string = '') {
        return String(value || '').trim().toLowerCase();
    }

    public openSignup() {
        this.signupData = {
            email: this.data.email || '',
            name: '',
            mobile: '',
            department: '',
            password: '',
            passwordConfirm: ''
        };
        this.signupOpen = true;
        this.service.render();
    }

    public closeSignup() {
        if (this.signupLoading) return;
        this.signupOpen = false;
        this.service.render();
    }

    public async login() {
        if (this.loading) return;

        let user = JSON.parse(JSON.stringify(this.data));
        user.email = this.normalizeLoginId(user.email);
        if (!user.email) {
            await this.alert("아이디 또는 이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        this.loading = true;
        await this.service.render();
        try {
            let { code, data } = await wiz.call("login", user);

            if (code == 200) {
                location.href = this.returnTo();
                return;
            }

            await this.alert(data?.message || "로그인에 실패했습니다.", code == 403 ? 'warning' : 'error');
        } catch (e) {
            await this.alert("요청 처리 중 오류가 발생했습니다.", 'error');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async signup() {
        if (this.signupLoading) return;

        let user = JSON.parse(JSON.stringify(this.signupData));
        user.email = this.normalizeEmail(user.email);
        user.name = String(user.name || '').trim();
        user.mobile = String(user.mobile || '').trim();
        user.department = String(user.department || '').trim();

        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }
        if (!user.password || user.password.length < 8) {
            await this.alert("비밀번호는 8자 이상 입력해주세요.");
            return;
        }
        if (user.password !== user.passwordConfirm) {
            await this.alert("비밀번호 확인이 일치하지 않습니다.");
            return;
        }

        this.signupLoading = true;
        await this.service.render();
        try {
            let { code, data } = await wiz.call("signup", user);

            if (code == 200) {
                this.signupOpen = false;
                this.signupLoading = false;
                this.data.email = user.email;
                this.data.password = '';
                await this.service.render();
                await this.alert(data?.message || "회원가입 승인 요청이 완료되었습니다.", 'success');
                return;
            }

            await this.alert(data?.message || "회원가입에 실패했습니다.", 'error');
        } catch (e) {
            await this.alert("요청 처리 중 오류가 발생했습니다.", 'error');
        } finally {
            this.signupLoading = false;
            await this.service.render();
        }
    }
}

export default PageAccessComponent;